import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

// import { NavigationService } from "@core/services/navigation/navigation.service";
import { ModalController } from "@ionic/angular";
import { BaseProductCommand } from "@shared/commands/base-product.command";
import { IProductCommandContext } from "@shared/models/command";
import { ProductTypes } from "@shared/models/products.model";
import { CommandAvailabilityService } from "@shared/services/command-availability.service";
import { SalaryOrPensionTransferComponent } from "../../_modals/salary-or-pension-transfer/salary-or-pension-transfer.component";
import { TypeUtilService } from "@core/services/utils/type-util.service";


@Injectable({
  providedIn: 'root'
})
export class SalaryOrPensionTransferRedirectCommand extends BaseProductCommand {
  readonly type = 'salaryOrPensionTransferRedirect';
  readonly title = 'Перевести зарплату или пенсию';
  icon = 'card';
  productType = ProductTypes.CARD;
  isInfoAction: boolean;
  settingsNames = undefined;
  order = 11;

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private modalCtrl: ModalController
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<unknown> {
    const modal = await this.modalCtrl.create({
      component: SalaryOrPensionTransferComponent,
      handle: false,
      cssClass: 'custom',
      initialBreakpoint: 1,
      componentProps: {
        product: context.data
      }
    });

    modal.present();

    return;
  }

  protected checkAdditionalAvailability({data: card}: IProductCommandContext): Observable<boolean> | boolean | undefined {
    const isMomentum = TypeUtilService.isTruthy(card.isMomentum);
    const isSalary = TypeUtilService.isTruthy(card.isSalary);
    const {status, type, isVirtual, isDebitCard} = card;
    const isBlocked = status === 'block';
    const isCredit = type === '5';
    const isOverdraft = type === '6';

    return (
      isDebitCard && !isVirtual && !isMomentum && !isSalary && !isBlocked && !isCredit && !isOverdraft
    );
  }
}
